export default __webpack_public_path__ + "static/media/allocation_stop.557fb74d.svg";